import { Component, inject, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../services/global.service';
import { ButtonComponent } from '../../components/button/button.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { TextInputComponent } from '../../components/text-input/text-input.component';
import { PluralPipe } from '../../pipes/plural.pipe';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { ProgramService } from '../../services/program.service';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { SelectInputComponent } from "../../components/select-input/select-input.component";
import { DropdownService } from '../../services/dropdown.service';
import { ValidationService } from '../../services/validation.service';
import { DropdownUploadButtonComponent } from '../../components/dropdown-upload-button/dropdown-upload-button.component';
import { FormService } from '../../services/form.service';
@Component({
  selector: 'app-program-list-page',
  imports: [HeaderComponent, ButtonComponent, CommonModule, FormsModule, ConfirmationPopupComponent, ModalComponent, TextInputComponent, ReactiveFormsModule, PluralPipe, AgGridListComponent, SearchInputComponent, BulkUploadComponent, SelectInputComponent, DropdownUploadButtonComponent],
  templateUrl: './program-list-page.component.html',
  styleUrl: './program-list-page.component.css'
})

export class ProgramListPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('form_modal') form_modal: ModalComponent | undefined;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any;

  page_name = 'Program';
  form: FormGroup;
  params: any = {};
  selected_program_ids: any = {}
  items: any[] = [];
  isSubmitting = false;
  show_menu = false;
  fs = inject(FormService);

  country_cols: any = [
    { field: 'name', headerName: 'Program Name', filter: true, flex: 1, },
    { field: 'code', headerName: 'Code', filter: true, flex: 1, },
    { field: 'Level.name', headerName: 'Level', filter: true, flex: 1, },
    { field: 'University.name', headerName: 'University', filter: true, flex: 1, },
    { headerName: 'Contact', filter: true, flex: 2, cellRenderer: (p: any) => { const contact = p.data?.contact || ''; const email = p.data?.email || ''; if (contact && email) return `<div style="display:flex;flex-direction:column;justify-content:center;padding:6px 0;line-height:1.4;overflow:hidden"><span style="color:#111;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${contact}</span><span style="color:#888;font-size:13px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${email}</span></div>`; return contact || email || '-'; } },
    { headerName: "", sortable: false, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', width: 130, minWidth: 130, maxWidth: 130 }
  ];

  bulk_columns_download: any = [
    { column_name: 'Program Name', type: 'text', return_as: 'name' },
    { column_name: 'Code', type: 'text', return_as: 'code' },
    { column_name: 'University', type: 'text', return_as: 'University.name', download_bind: 'University.name' },
    { column_name: 'Level', type: 'text', return_as: 'Level.name', download_bind: 'Level.name' },
    { column_name: 'Contact', type: 'text', return_as: 'contact' },
    { column_name: 'Email', type: 'text', return_as: 'email' },
  ];

  bulk_columns = [
    { column_name: 'Program Name', type: 'text', return_as: 'name', sample_value: 'UG', is_unique: true, min_length: this.vs.min_length_name, max_length: this.vs.max_length_name, regex: this.vs.name_pattern, regex_error: `Please enter a valid ${this.page_name} Name` },
    { column_name: 'Program Code', type: 'text', return_as: 'code', sample_value: 'UG', is_unique: true, min_length: this.vs.min_length_code, max_length: this.vs.max_length_code, unique_error: 'Program code already exists', regex: this.vs.code_pattern },
    { column_name: 'University', type: 'link', linked_list: 'university_list', returning_key: 'id', return_as: 'university_id', sample_value: 'ABC University' },
    { column_name: 'Level Name', type: 'link', linked_list: 'level_list', returning_key: 'id', return_as: 'level_id', sample_value: 'One' },
    { column_name: 'Email', type: 'text', return_as: 'email', sample_value: 'abc@gmail.com', skip_validation: true },
    { column_name: 'Contact', type: 'text', return_as: 'contact', sample_value: '1234567890', skip_validation: true }

  ];
  actions(row: any) {
    let actions: any = []
    actions.push({ text: row.is_active ? 'Disable' : 'Enable', shortcut: 'u', color: 'gray', icon: row.is_active ? 'bx bx-block' : 'bx bx-check-circle', function: this.disable.bind(this), permissions: this.gs.user_role_data?.masters_course_disable })
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this), permissions: this.gs.user_role_data?.masters_course_view })
    actions.push({ text: 'Edit', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', disabled: row.is_active === false, function: this.open_form_modal.bind(this), permissions: this.gs.user_role_data?.masters_course_update })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.delete.bind(this), permissions: this.gs.user_role_data?.masters_course_delete })
    return actions
  }
  constructor(public gs: GlobalService, public route: Router, public fb: FormBuilder, public ps: ProgramService, public ar: ActivatedRoute, public ds: DropdownService, public vs: ValidationService) {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(this.vs.min_length_name), Validators.maxLength(this.vs.max_length_name), Validators.pattern(this.vs.name_pattern)]],
      code: ['', [Validators.required, Validators.minLength(this.vs.min_length_code), Validators.maxLength(this.vs.max_length_code), Validators.pattern(this.vs.code_pattern)]],
      university_id: ['', [Validators.required]],
      level_id: ['', [Validators.required]],
      email: ['', [Validators.pattern(this.vs.email_pattern), Validators.maxLength(this.vs.max_length_email)]],
      contact: ['', [Validators.minLength(this.vs.min_length_contact), Validators.maxLength(this.vs.max_length_contact),]],
      is_active: [true]
    });
  }
  async ngOnInit() {
    await this.ds?.get_dropdown_list(['role', 'university', 'level']);
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
      // Access Level: lock the filters this user cannot change before the first fetch.
      this.gs.apply_access_scope_to_params(this.params);
      await this.get_list(this.params)
    })
  }
  async get_list(filter?: any) {
    try {
      const res = await this.ps.get_list(filter);
      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }

  onFilterChange() {
    this.get_list({ ...this.params, page: 1 });
  }

  download() {
    this.fs.bulk_download(this.ps, 'get_list', this.bulk_columns_download, 'Program', this.params);
  }
  async delete(item: any, index: any) {
    this.selected_program_ids = item;
    this.confirmation_delete_modal?.open();
  }
  async disable(item: any, index: any) {
    this.selected_program_ids = item;
    this.confirmation_disabled_modal?.open();
  }

  open_view_modal(item: any) {
    console.log(item);
    this.selected_program_ids = item || {};
    this.view_modal?.open();
  }
  async delete_program() {
    let res = await this.ps.delete(this.selected_program_ids.id);
    if (res != undefined) {
      this.gs.toastr_shows_function(res?.message, 'Success', 'success');
    }
    this.selected_program_ids = {};
    this.confirmation_delete_modal?.close()
    this.ds.invalidate_dropdown_cache('program');
    await this.get_list(this.params);
  }

  async update_country(item: any) {
    try {
      let form_value = this.form.value;
      let data = item == true ? form_value.is_active == false : form_value.is_active == true
      let update = await this.ps.update(this.selected_program_ids.id, { is_active: data });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_delete_modal?.close()
      this.ds.invalidate_dropdown_cache('program');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async bulk_delete(ids: any[]) {
    try {
      for (let id of ids) {
        let res = await this.ps.delete(id);
      }
      this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
      this.ds.invalidate_dropdown_cache('program');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async open_form_modal(item?: any) {
    this.selected_program_ids = item || {};
    if (this.selected_program_ids && this.selected_program_ids.id) {
      let response = await this.ps.get(item.id);
      this.selected_program_ids = this.gs.addHierarchyIds({ ...response.data });
      this.form.patchValue({ ...this.selected_program_ids, });
    } else {
      this.selected_program_ids = {};
      this.form.reset();
    }
    this.form_modal?.open();
  }
  close_form_modal(): void {
    this.form_modal?.close();
  }
  async submit_program() {
    try {
      if (this.isSubmitting) {
        return;
      }
      if (this.form.invalid) {
        this.gs.toastr_shows_function('Please fill all required fields correctly.', 'Error', 'error');
        this.form.markAllAsTouched();
        return;
      }
      this.isSubmitting = true;
      let form_value = this.form.value;
      form_value.is_active = true;
      if (this.selected_program_ids && this.selected_program_ids.id) {
        let update_response = await this.ps.update(this.selected_program_ids.id, form_value);
        this.gs.toastr_shows_function('Changes updated successfully', 'Success', 'success');
      } else {
        let create_response = await this.ps.add(form_value);
        this.gs.toastr_shows_function(create_response?.message, 'Success', 'success');
      }
      this.ds.invalidate_dropdown_cache('program');
      await this.get_list(this.params);
      this.close_form_modal();
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    } finally {
      this.isSubmitting = false;
    }
  }
  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        is_active: true,
        // contect:item.contect+''
      }));
      await this.gs.bulk_form_submission(updatedData, this.ps, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
}
